import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import _noop from 'lodash/noop';

import Button from '@mlb/react-patterns/components/Button/button.tsx';
import { IconWrapper } from '@mlb/react-patterns/components/Icon/icon.style.tsx';

const Wrapper = styled.div`
    padding: 0px 22px;
`;

const Option = styled(Button)`
    display: flex;
    width: 100%;
    padding-left: 0px;
    padding-right: 0px;
    color: ${({ selected }) => selected ? '#E6E6E6' : '#B3B3B3'};
    justify-content: space-between;
    align-items: center;

    ${IconWrapper} {
        stroke: none;
    }
`;

const Content = ({
    options,
    selected,
    dictionary,
    onOptionClick,
}) => {

    return (
        <Wrapper>
            {
                options && options.map((option, index) => {

                    const optionLabel = option?.label || '';
                    const optionIsSelected = option?.value === selected?.value;

                    return (
                        <Option
                            label={optionLabel}
                            key={index}
                            size={'lg'}
                            shape={'hollow-borderless'}
                            selected={optionIsSelected}
                            handlers={
                                {
                                    onClick: () => onOptionClick(option),
                                }
                            }
                            additionalProps={{
                                'aria-label': `${optionLabel}${optionIsSelected ? ` ${dictionary?.selected || 'Selected'}` : ''}`,
                            }}
                            aria-label={optionLabel}
                            iconName={optionIsSelected && 'checkmark'}
                            iconLeft={false}
                            iconColor={'#2196F3'}
                            iconSize={18}
                        />
                    );

                })
            }
        </Wrapper>
    );

};

Content.propTypes = {
    options: PropTypes.arrayOf(
        PropTypes.shape({
            value: PropTypes.string,
            label: PropTypes.string,
        })
    ).isRequired,
    selected: PropTypes.shape({
        value: PropTypes.string,
        label: PropTypes.string,
    }),
    dictionary: PropTypes.object,
    onOptionClick: PropTypes.func,
};

Content.defaultProps = {
    selected: null,
    dictionary: {},
    onOptionClick: _noop,
};

export default Content;
